import { ApiResponse, Season } from '@collector/sportsapi-client-legacy'

import { HttpClient } from '../../httpClient.js'
import { SeasonDetail } from './types.js'

export type SeasonDetailsGetByIdResponse = ApiResponse<SeasonDetail[]>

export async function getBySeasonId(
  httpClient: HttpClient,
  seasonId: Season['id'],
): Promise<SeasonDetailsGetByIdResponse> {
  return httpClient.url(`/seasons/${seasonId}/details`).get().json()
}
